module.exports = __webpack_public_path__ + "static/media/multiAhorro.cfbb1c4f.svg";